import { createAPIConnection } from 'services';
import { requestHandler } from '../helpers';
import {
	GetCurrentCampaignRequest,
	GetCurrentCampaignResponse,
	GetCurrentCampaignPackagesRequest,
	GetCurrentCampaignPackagesResponse,
	GetCurrentCampaignPerformanceRequest,
	GetCurrentCampaignPerformanceResponse,
	GetCurrentCampaignProductsRequest,
	GetCurrentCampaignProductsResponse,
} from './interfaces';

const api = createAPIConnection('/campaigns/current');

/**
 * Retrieves information about the current active campaign for a POS.
 *
 * @param params - Request parameters.
 * @returns The current campaign information.
 */
export async function getCurrentCampaign({ posId }: GetCurrentCampaignRequest) {
	return requestHandler<GetCurrentCampaignResponse>(
		api.get('', {
			params: {
				posId,
			},
		}),
	);
}

/**
 * Retrieves the list of challenge packages available in the current campaign.
 *
 * @param params - Request parameters.
 * @returns The available campaign challenge packages.
 */
export async function getCurrentCampaignPackages({ posId }: GetCurrentCampaignPackagesRequest) {
	return requestHandler<GetCurrentCampaignPackagesResponse>(
		api.get('/packages', {
			params: {
				posId,
			},
		}),
	);
}

/**
 * Retrieves performance information for a specific campaign challenge.
 *
 * @param params - Request parameters.
 * @returns Performance metrics and challenge configuration.
 */
export async function getCurrentCampaignPerformance({ packageId, posId }: GetCurrentCampaignPerformanceRequest) {
	return requestHandler<GetCurrentCampaignPerformanceResponse>(
		api.get(`/packages/${packageId}/performance`, {
			params: {
				posId,
			},
		}),
	);
}

/**
 * Retrieves a paginated list of products belonging to a campaign challenge.
 *
 * Supports text search and filtering by facets, mandatory products,
 * booster products, and purchased status.
 *
 * @param params - Request parameters.
 * @returns A paginated list of campaign products.
 */
export async function getCurrentCampaignProducts({ posId, packageId, ...params }: GetCurrentCampaignProductsRequest) {
	const payload = params;
	const query = { params: { posId } };

	return requestHandler<GetCurrentCampaignProductsResponse>(
		api.post(`/packages/${packageId}/products`, payload, query),
	);
}
